(function () {
  const fromDate = document.querySelector(".patient-feedback form #date-from");
  const toDate = document.querySelector(".patient-feedback form #date-to");
  const feedbackImpSubmit = document.querySelector(
    ".patient-feedback form #export-feedback-csv"
  );
  const csvMessage = document.querySelector("#pharmacy-finder-modal-trigger");
  const modalMessage = document.querySelector(".message-text");

  if (feedbackImpSubmit) {
    feedbackImpSubmit.addEventListener("click", (e) => {
      e.preventDefault();
      exportPatientFeedback(fromDate,toDate);
    });
  }

  function exportPatientFeedback(fromDate,toDate) {
    // Ajax request
    let request = new XMLHttpRequest();
    request.open("POST", glide_custom_data.ajax_url, true);
    request.setRequestHeader(
      "Content-Type",
      "application/x-www-form-urlencoded; charset=UTF-8"
    );

    request.responseType = "blob"; // Set response type to blob for file download

    glide_ajax_loader_show();

    request.onreadystatechange = () => {
      let errorFlag = false;
      if (request.readyState === 4 && request.status === 200) {
        const blob = new Blob([request.response], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download =
          "Glide-Patient-Feedback-Export-" +
          new Date().toISOString().slice(0, 10) +
          ".csv";
        document.body.appendChild(link); // Append to body to make it clickable
        link.click();
        document.body.removeChild(link); // Remove link after clicking
      } else if (request.readyState === 4) {
        const reader = new FileReader();
        reader.onload = function(){
          try{
            const response = JSON.parse(reader.result);
            csvMessage.click();
            glide_ajax_loader_hide();
            modalMessage.innerHTML = `<p>${response.data}</p>`;
          }catch(e){
            console.error("Error parsing JSON response",e);
            csvMessage.click();
            glide_ajax_loader_hide();
            modalMessage.innerHTML = `<p>An unexpected error occured</p>`;
          }
        }
        reader.readAsText(request.response); // Convert Blob to text
      }
    };
    // Send the request
    const postData =
      `action=export_feedback&nonce=${encodeURIComponent(
        glide_custom_data.ajax_nonce
      )}` + "&fromDate="+fromDate.value+"&toDate="+toDate.value;
    request.send(postData);
  }
})();
